export default __webpack_public_path__ + "static/media/arrow-left.04a43076.svg";